import {
  RawApiClient,
  throwNon200ResponseTransformer,
} from '@plangrid-private/web-api-clients';
import goldenGateRequestTransformer from '@plangrid-private/web-api-clients/dist/rawClients/goldenGateRequestTransformer';

const rawPhotosServiceClient = new RawApiClient({
  requestTransformers: [goldenGateRequestTransformer('photosbackend')],
  responseTransformers: [throwNon200ResponseTransformer],
});

export default rawPhotosServiceClient;
